module.exports = __webpack_public_path__ + "portal-static/img/4.a5ef78d2.jpg";